import { render, staticRenderFns } from "./surplus.vue?vue&type=template&id=8903a02a"
import script from "./surplus.vue?vue&type=script&lang=js"
export * from "./surplus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports